<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester date keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學號/工號-姓名</th>
                            <th>日期</th>
                            <th>地點</th>
                            <th>原因</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.InjuryRecordID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.InjuryRecordID" /></td>
                        <td data-th="學號/工號-姓名"><b-button size="sm" variant="link" @click="edit(item.InjuryRecordID)">{{item.No}}-{{item.Name}}</b-button></td>
                        <td data-th="日期">{{item.Date|date('yyyy/mm/dd hh:MM')}}</td>
                        <td data-th="地點">{{item.Place|place}}</td>
                        <td data-th="原因">{{item.Reason}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="place">
                <div is="option" v-for="o in places" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './injuryrecordDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'injuryrecord',
        api: '/api/injuryrecord/',
        components: { Detail },
        data: { places: [] },
        created: function () {
            window.places = [];
            this.$parameter.injuryplaces().then((res) => { window.places = this.places = res.data; });
        },
        filters: {
            place: function (value) { let a = window.places.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
    });
</script>

<style>
</style>